// Espaciados centralizados
export const spacing = {
  // Espaciado base (8px)
  base: 8,

  // Espaciados predefinidos
  xs: 4, // 4px
  sm: 8, // 8px
  md: 16, // 16px
  lg: 24, // 24px
  xl: 32, // 32px
  '2xl': 48, // 48px
  '3xl': 64, // 64px

  // Espaciados específicos
  padding: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
  },

  margin: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
  },

  // Espaciados de componentes
  component: {
    padding: '16px',
    margin: '8px',
    gap: '12px',
  },

  // Espaciados de layout
  layout: {
    container: '24px',
    section: '32px',
    page: '48px',
  },
};
